export default __webpack_public_path__ + "maps-examples-draggable-views-thumbnail-960-4f836823c0d4f4c5b08862401b52f862.png";